import type { Submission } from "@shared/common/types/form";

export const fetchSubmission = ({
  campaignId,
  userId,
  properties,
  data,
}: {
  campaignId: string;
  userId: string | null;
  properties?: Record<string, unknown> | null;
  data: Record<string, Submission>;
}) => {
  return fetch(`${FORM_API_BASE_URL}/api/v1/submit-event`, {
    method: "POST",
    body: JSON.stringify({ campaignId, userId, properties, data }),
  });
};
